import { render, staticRenderFns } from "./boxesList.vue?vue&type=template&id=6637c276&scoped=true&"
import script from "./boxesList.vue?vue&type=script&lang=js&"
export * from "./boxesList.vue?vue&type=script&lang=js&"
import style0 from "./boxesList.vue?vue&type=style&index=0&id=6637c276&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6637c276",
  null
  
)

component.options.__file = "boxesList.vue"
export default component.exports